/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */
const triggerAnalyticsForApp =
	(_appName: string) =>
	(_eventNameSuffix: string, _eventData: unknown): Promise<void> =>
		Promise.resolve(undefined);

/**
 * Exports a function that will automatically namespace any triggered
 * events with the String `project-settings.details`.
 * See {@link /common/util/analytics/trigger-analytics.js} for the complete details.
 *
 * Params of the exported function:
 * @param String eventName of the analytics event
 * @param Object data to be sent alongside the event
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnalyticsTrigger = (eventName: string, data?: any) => Promise<void>;

const triggerAnalytics: AnalyticsTrigger = triggerAnalyticsForApp('project-settings.details');

/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */
export default triggerAnalytics;
